import React from 'react';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { Section, SectionContent } from 'src/shared/components';

import styles from './PhraseSection.module.scss';

const PhraseSection = () => {
	const { t } = useTranslation();

	return (
		<Section name="phrase" classes={{ section: styles.section }}>
			<SectionContent>
				<Col md={10}>
					<AnimationOnScroll animateIn="animate__fadeInDown" animateOut="animate__fadeOutUp" delay={200}>
						<p className={styles.text}>{t('phraseSection.text')}</p>
					</AnimationOnScroll>
					<AnimationOnScroll animateIn="animate__fadeInUp" animateOut="animate__fadeOutDown" delay={400}>
						<h3 className={styles.title}>{t('phraseSection.title')}</h3>
					</AnimationOnScroll>
				</Col>
			</SectionContent>
		</Section>
	);
};

export default PhraseSection;
